import React from "react";
import IEPCardDesignsThumbs from "./IEPCardDesignsThumbs";

function IEPCardDesigns() {
  return (
    <section className="card-iep-designs">
      <div className="content-row">
        <article className="content">
          <h2 className="title">Exploring solutions</h2>
          <p>
            I conducted multiple presentations to product and business owners on
            possible UX/UI solutions, in the form of high resolution wireframes
            and click-thru user journeys. I guided the design meetings so as to
            better define some core{" "}
            <strong>
              {" "}
              <a
                className="link-inline"
                href="https://www.nngroup.com/articles/personas-jobs-be-done/"
                target="_blank"
                rel="noopener noreferrer"
              >
                jobs-to-be-done
              </a>{" "}
            </strong>
            .
          </p>
        </article>
        <div className="mask">
          <IEPCardDesignsThumbs />
        </div>
      </div>
    </section>
  );
}

export default IEPCardDesigns;
